import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

const AppButton = styled(MuiButton)(() => ({
  background: "#3ecf8e",
  textTransform: "capitalize",
  fontSize: "14px",
  padding: "4px 16px",
  color: "white",
}));

export default AppButton;
